import { useQueryClient, useMutation } from '@tanstack/react-query';
import { updateStructuralHierarchySubOrg } from "../orgPanelApiCalls";
import { key as structuralHierachyKey } from "../queries/useStructuralHierachyQuery";
import { useStore } from "../appStore";

const useUpdateHierachySuborgMutation = () => {
    const queryClient = useQueryClient()
    const orgId = useStore((state) => state.CurrentOrganizationId);
    return useMutation({
        mutationFn: async (variables) => {
            const data = await updateStructuralHierarchySubOrg(orgId, variables.parentId, variables.accountId, variables.name);

            return data;
         },
        onSuccess: (data, variables) => {
            queryClient.setQueryData([structuralHierachyKey], (oldData) => {
                return oldData.map((item) => {

                    if (item.accountId === variables.accountId) {
                        return {
                            ...item,
                            name: variables.name
                        }
                    }
                    return item;
                });
            });
        },
    })
}

export { useUpdateHierachySuborgMutation };